import Vue from 'vue'
import Components from './components'
import store from './store'
import VueMask from "v-mask";
import Vuelidate from 'vuelidate'
import Moment from 'vue-moment'
import moment, { calendarFormat } from 'moment-timezone'
import {BASE_URL_APP, PATH_SEM_IMAGE } from  './http'
import Pages from './pages'
import Methods from './methods'
import {mapActions, mapGetters, mapState} from 'vuex'
import * as VueGoogleMaps from 'vue2-google-maps'
// import infiniteScroll from 'vue-infinite-scroll'
import VueClipboard from 'vue-clipboard2'
import VueFileAgent from 'vue-file-agent';
import  'vue-file-agent/dist/vue-file-agent.css';

(() => {
    setTimeout(() => {
        $.each($('img'), function() {
            if ( $(this).attr('data-src') && $(this).offset().top < ($(window).scrollTop() + $(window).height() + 30) ) {
                var source = $(this).data('src');
                $(this).attr('src', source);
                $(this).removeAttr('data-src');
            }
        })
    }, 1500)
})()

import VueSweetalert2 from 'vue-sweetalert2'
import 'sweetalert2/dist/sweetalert2.min.css'
import { io } from 'socket.io-client';
import { googleMapsApiKey } from './services/config';
import { map } from 'lodash';

moment.locale("pt-br");
moment.localeData("pt-br");

Object.entries(Pages).map(([name, page]) => {
    Components[name] = page
})
Vue.prototype.$baseUrl = BASE_URL_APP
Vue.prototype.$pathSemImagem = PATH_SEM_IMAGE
Vue.prototype.$colorLoading =  '#eb2771'
Vue.prototype.$pathFilesSystem = process.env.MIX_PATH_FILES_SYSTEM
Vue.prototype.$socket = null

Vue.use(VueMask)
Vue.use(Vuelidate)
Vue.use(Moment)
Vue.use(VueClipboard)
Vue.use(VueFileAgent);

Vue.use(VueSweetalert2)
// Vue.use(infiniteScroll)

Vue.use(VueGoogleMaps, {
    load: {
      key: googleMapsApiKey,
      libraries: 'places',
    }
  });

const app = new Vue({
    store,
    el: '#app',
    components: Components,

    async mounted() {
        await this.ActionGetModules()
        let val = this.company;

        if(!val)return
            const data = {
                path: window.location.pathname,
                company_id: val.id,
            }
            this.ActionSetAccessManagement(data).catch(e => {})
            if(this.user_logged) {
                sessionStorage.setItem('login', true)
                this.ActionGetToken()
                .then(r => {
                    Vue.prototype.$socket = io(process.env.MIX_WS_NODE_HOST, {
                        extraHeaders: {
                            authorization:
                                `Bearer ${r.data.token}`,
                        },
                    });
                    this.$socket.on(`site-private.${this.user_id}.${val.id}`, (e) =>
                        this.ActionSetPrivate(e));
                })
                .catch(console.log)
                this.ActionSetUserId(this.user_id)
                .then(() => {
                    this.ActionCheckClientApproved()
                })
            }
            if(!this.use_location_popup){
                if(val.use_location == true || val.require_location) {
                    this.ActionGetAccessLocation()
                    .then(() => {
                        this.actionCheckAccessLocation().catch(e=>{})
                    }).catch(e => {})
                }
            }
    },
    methods: {
        ...Methods,
        ...mapActions("location", [
            "ActionGetAccessLocation",
            'actionCheckAccessLocation',
            'ActionSetUserId'
        ]),
        ...mapActions('broadcast', [
            'ActionSetGlobal',
            'ActionSetPrivate',
            'AcionsBroadcast',
            'ActionGetToken'
        ]),
        ...mapActions('clients', [
            'ActionCheckClientApproved'
        ]),
        ...mapActions('company', [
            'ActionSetAccessManagement'
        ]),
        ...mapActions('modules', ['ActionGetModules'])
    },
    computed: {
        ...mapState('company', ['company']),
        ...mapState('location', [
            'location'
        ]),
        ...mapState('broadcast', [
            'private'
        ]),
        ...mapGetters('company', [
            'use_location_popup'
        ]),
        user_logged() {
            return this.$root.$children[0].$attrs.logged
        },
        user_id() {
            return this.$root.$children[0].$attrs.user_id
        },
    },
    watch: {
        private({data}) {
            if(data.method) {
                this.AcionsBroadcast()
                .then((actions) => {
                    actions[data.method](this.user_id, this.company.id, data)
                }).catch((err) => {

                });

            }
        },
    }
});
